export const translations = {
  tr: {
    // Navigation
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      rooms: 'Odalar',
      dining: 'Yeme & İçme',
      spa: 'Spa & Fitness',
      pool: 'Havuz & Plaj',
      entertainment: 'Eğlence',
      kids: 'Çocuk Kulübü',
      gallery: 'Galeri',
      contact: 'İletişim',
      bookNow: 'Rezervasyon',
    },
    // Hero
    hero: {
      title: "Ege'nin En Yeni İncisi",
      subtitle: 'Holiday Inn Resort Bodrum West Beach',
      opening: '',
      concept: 'Ultra Her Şey Dahil & Aile Dostu',
      location: 'Turgutreis, Bodrum',
      cta: 'Rezervasyon Yap',
    },
    // About
    about: {
      title: 'HOŞ GELDİNİZ',
      subtitle: 'Tesis Hakkında',
      openingDate: '',
      openingDateValue: '',
      category: 'Kategori',
      categoryValue: '5 Yıldız',
      concept: 'Konsept',
      conceptValue: 'Ultra Her Şey Dahil',
      totalArea: 'Toplam Alan',
      totalAreaValue: '47.000 m²',
      capacity: 'Kapasite',
      capacityValue: '460 Oda',
      targetAudience: 'Hedef Kitle',
      targetAudienceValue: 'Aileler, Çiftler, Balayı Misafirleri',
      description: 'Holiday Inn Resort Bodrum West Beach, 47.000 m² alan üzerinde 460 oda kapasitesiyle Ultra Her Şey Dahil konseptinde hizmet verecek. Kos ve Kalymnos adalarına hakim panoramik Ege denizi manzarası ile unutulmaz bir tatil deneyimi sunuyoruz.',
    },
    // Location
    location: {
      title: 'Lokasyon ve Ulaşım',
      subtitle: 'Eşsiz Konum',
      address: 'Adres',
      addressValue: 'Turgutreis, Bahçelievler Mah. Zeyyat Mandalinci Cad. No:164',
      view: 'Manzara',
      viewValue: 'Kos ve Kalymnos adalarına hakim, panoramik Ege denizi manzarası',
      highlights: 'Öne Çıkanlar',
      highlightsValue: 'Turgutreis Marina\'ya yakın, denize sıfır konum',
      transport: 'Ulaşım',
      transportValue: 'Bodrum şehir merkezine ve havaalanına kolay ulaşım imkanı',
    },
    // Rooms
    rooms: {
      title: 'Konaklama',
      subtitle: 'Modern ve Konforlu Odalar',
      description: 'Toplam 460 oda ile geniş konaklama seçenekleri. Her misafir profiline uygun oda tipleri.',
      premium: {
        title: 'Premium Odalar',
        subtitle: 'Standartta Yüksek Konfor',
        size: '30 m²',
        description: 'Çiftler veya tek çocuklu aileler için ideal. Modern tasarım, balkon/teras ve şık dekorasyon.',
      },
      premiumSea: {
        title: 'Premium Deniz Manzaralı',
        subtitle: 'Mavinin Her Tonu',
        size: '30 m²',
        description: 'Panoramik Ege Denizi manzarası. Gün boyu ferah ve huzurlu bir ortam, gün batımı keyfi.',
      },
      swimUp: {
        title: 'Swim-Up Odalar',
        subtitle: 'Ayrıcalıklı Tatil Deneyimi',
        size: '30-40 m²',
        description: 'Odanızın terasından sadece birkaç adımda havuza doğrudan erişim. Güneşlenme terası ve şezlong imkanı.',
      },
      family: {
        title: 'Aile Odaları',
        subtitle: 'Geniş Aileler İçin İdeal',
        size: '40 m²',
        description: 'Ebeveyn ve çocuklar için rahat hareket alanı sağlayan geniş mimari. 4 kişilik ailelerin konforla konaklayabileceği düzen.',
      },
      connection: {
        title: 'Bağlantılı Odalar',
        subtitle: 'Daha Fazla Alan',
        size: '60 m²',
        description: 'İki ayrı odanın birleşimiyle hem birliktelik hem mahremiyet sağlar.',
      },
      juniorSuite: {
        title: 'Junior Suit (1+1)',
        subtitle: 'Konforlu ve Geniş',
        size: '80 m² (1+1)',
        description: 'Geniş yaşam alanı, modern tasarım ve ebeveyn yatak odası ile ayrıcalıklı konaklama sunar.',
      },
      queenSuite: {
        title: 'Queen Suit (2+1)',
        subtitle: 'Üst Düzey Lüks',
        size: '105 m² (2+1)',
        description: 'Panoramik deniz manzarası, iki yatak odası ve geniş salonu ile aileniz için kusursuz konfor.',
      },
      kingSuite: {
        title: 'King Suit (3+1)',
        subtitle: 'Ultra Lüks ve Prestij',
        size: '150 m² (3+1)',
        description: 'Geniş yaşam alanları, üç yatak odası, lüks detayları ve eşsiz panoramik manzarası ile en üst düzey tatil deneyimi.',
      },
      viewOptions: 'Manzara Seçenekleri',
      gardenView: 'Bahçe Manzaralı',
      poolView: 'Havuz Manzaralı',
      seaView: 'Deniz Manzaralı',
    },
    // Dining
    dining: {
      title: 'Yeme & İçme',
      subtitle: '24 Saat Lezzet Deneyimi',
      concept: 'Ultra Her Şey Dahil konseptimizle sabah kahvaltısından gece büfesine kadar gün boyu kesintisiz yiyecek servisi.',
      premium: 'Premium İçecekler: Konsept dahilinde 3 farklı Viski markası ve 3 farklı Cin markası ücretsiz olarak sunulmaktadır.',
      mainRestaurant: {
        title: 'Ana Restoran',
        subtitle: 'Açık Büfe Lezzet Şöleni',
        breakfast: 'Kahvaltı: 07:00 – 10:00',
        lateBreakfast: 'Geç Kahvaltı: 10:00 – 10:30',
        lunch: 'Öğle Yemeği: 12:30 – 14:00',
        dinner: 'Akşam Yemeği: 19:00 – 21:30',
        nightService: 'Gece Servisi: Gece Çorbası (23:00-24:00) ve Gece Büfesi (00:00-02:00)',
      },
      snacks: {
        title: 'Snack ve Atıştırmalıklar',
        subtitle: 'Gün Boyu Enerji',
        items: [
          'Snack Restoran: 12:00 – 16:00',
          'Sahil Snack: 12:00 – 18:00',
          'Gözleme Köşesi: 11:00 – 14:30',
          'Waffle: 14:30 – 15:30',
          'Pastane: 12:00 – 18:00',
        ],
      },
      alaCarte: {
        title: 'A La Carte Restoranlar',
        subtitle: 'Dünya Mutfaklarından Seçkiler',
        italian: 'İtalyan Restoran: 19:30 – 21:30 (Haftanın 6 günü)',
        international: 'Uluslararası Restoran: 19:30 – 21:30 (Haftanın 6 günü)',
        note: 'Rezervasyonludur ve kuver ücretlidir. Minimum 5 gece konaklamalarda 1 kez ücretsiz.',
      },
      bars: {
        title: 'Barlar',
        subtitle: 'Keyifli Molalar ve Premium İçkiler',
        lobby: 'Lobby Bar: 24 Saat açık',
        roof: 'Roof Bar: 19:00 – 24:00',
        pool: 'Pool Bar: 10:00 – 18:00 / 20:30 – 24:00',
        snack: 'Snack Bar: 11:00 – 17:30',
        beach: 'Sahil Bar: 10:00 – 18:00',
      },
    },
    // Pool & Beach
    pool: {
      title: 'Havuzlar & Plaj',
      subtitle: 'Serinletici Bir Mola',
      pools: {
        title: 'Havuzlar',
        pool1: 'Açık Havuz 1',
        pool2: 'Açık Havuz 2',
        kids: 'Çocuk Havuzu',
        indoor: 'Kapalı Havuz',
        note: 'Havuzlar 19:00 itibariyle temizlik için kapanır.',
      },
      beach: {
        title: 'Plaj',
        subtitle: 'Ege\'nin Tadını Çıkarın',
        location: 'Denize sıfır konum',
        features: 'Tesisin kendine ait özel plaj alanı',
        services: 'Şemsiye, şezlong ve plaj havlusu ücretsizdir',
        atmosphere: 'Modern konforla birleşen canlı sahil destinasyonu',
      },
    },
    // Spa & Fitness
    spa: {
      title: 'Spa & Fitness',
      subtitle: 'Yenilenme ve Dinamizm',
      fitness: {
        title: 'Fitness Salonu',
        description: 'Son teknoloji ekipmanlarla donatılmış spor salonu.',
      },
      wellness: {
        title: 'Ücretsiz Wellness',
        description: 'Türk Hamamı ve Sauna kullanımı.',
      },
      treatments: {
        title: 'Ücretli Bakımlar',
        description: 'Masaj paketleri, özel cilt bakımları ve SPA ritüelleri.',
      },
      goal: 'Hem bedensel formunuzu koruyun hem de zihinsel olarak rahatlayın.',
    },
    // Entertainment
    entertainment: {
      title: 'Eğlence ve Aktiviteler',
      subtitle: 'Tatilin Ritmini Yakalayın',
      liveMusic: {
        title: 'Canlı Müzik',
        description: 'Haftada 3 gün, profesyonel orkestralar eşliğinde canlı müzik keyfi.',
      },
      themeShows: {
        title: 'Tema Şovlar',
        description: 'Haftada 3 gün, sahne sanatları ve görsel şovlarla renklenen özel tema geceleri.',
      },
      dayActivities: {
        title: 'Gündüz Aktiviteleri',
        description: 'Gün boyu süren animasyon etkinlikleri ve havuz oyunları.',
      },
      aerobics: {
        title: 'Aerobik',
        description: 'Uzman eğitmenler eşliğinde enerji dolu Aerobik seansları.',
      },
    },
    // Kids Club
    kids: {
      title: 'Çocuk Kulübü',
      subtitle: 'Minik Misafirlere Büyük Eğlence',
      ageGroup: 'Yaş Grubu',
      ageGroupValue: '4-12 yaş',
      hours: 'Saatler',
      hoursValue: '10:00-12:30 ve 14:30-17:00',
      pool: 'Çocuk Havuzu',
      poolValue: '84 m² büyüklüğünde, 40 cm güvenli derinlik',
      activities: 'Aktiviteler',
      activitiesValue: 'Deneyimli eğitmenler eşliğinde oyun, yaratıcılık ve keşif aktiviteleri.',
    },
    // Services
    services: {
      title: 'Hizmetler',
      subtitle: 'Ücretli & Ücretsiz Hizmetler',
      free: {
        title: 'Ücretsiz Hizmetler',
        items: ['Wi-Fi (Tüm alanlarda)', 'Otopark', 'Masa Tenisi', 'Dart', 'Bebek Yatağı'],
      },
      paid: {
        title: 'Ücretli Hizmetler',
        items: ['Doktor', 'Çamaşırhane', 'Oda Servisi (00:00-08:00)', 'Su Sporları', 'Kuaför', 'Market', 'Araç Kiralama'],
      },
    },
    // Contact
    contact: {
      title: 'İletişim',
      subtitle: 'Bilmeniz Gerekenler',
      checkIn: 'Giriş',
      checkInValue: '14:00',
      checkOut: 'Çıkış',
      checkOutValue: '12:00',
      pets: 'Evcil Hayvan',
      petsValue: 'Kabul edilmemektedir',
      wristband: 'Kol Bandı',
      wristbandValue: 'Tesiste kol bandı kullanımı zorunludur',
      form: {
        title: 'Bize Ulaşın',
        name: 'Adınız Soyadınız',
        email: 'E-posta',
        phone: 'Telefon',
        subject: 'Konu',
        message: 'Mesajınız',
        send: 'Gönder',
        success: 'Mesajınız başarıyla gönderildi!',
      },
    },
    // Gallery
    gallery: {
      title: 'Galeri',
      subtitle: 'Fotoğraf Galerisi',
      all: 'Tümü',
      rooms: 'Odalar',
      restaurants: 'Restoranlar',
      pool: 'Havuz',
      beach: 'Plaj',
      spa: 'Spa',
    },
    // Footer
    footer: {
      quickLinks: 'Hızlı Erişim',
      contact: 'İletişim',
      followUs: 'Bizi Takip Edin',
      rights: '© 2026 Holiday Inn Resort Bodrum West Beach. Tüm hakları saklıdır.',
      ihg: 'IHG Hotels & Resorts',
    },
    // Common
    common: {
      learnMore: 'Daha Fazla',
      viewAll: 'Tümünü Gör',
      close: 'Kapat',
      loading: 'Yükleniyor...',
      error: 'Bir hata oluştu',
      required: 'Zorunlu alan',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      rooms: 'Rooms',
      dining: 'Dining',
      spa: 'Spa & Fitness',
      pool: 'Pool & Beach',
      entertainment: 'Entertainment',
      kids: 'Kids Club',
      gallery: 'Gallery',
      contact: 'Contact',
      bookNow: 'Book Now',
    },
    hero: {
      title: 'The Newest Pearl of the Aegean',
      subtitle: 'Holiday Inn Resort Bodrum West Beach',
      opening: '',
      concept: 'Ultra All-Inclusive & Family Friendly',
      location: 'Turgutreis, Bodrum',
      cta: 'Make Reservation',
    },
    about: {
      title: 'WELCOME',
      subtitle: 'About the Resort',
      openingDate: '',
      openingDateValue: '',
      category: 'Category',
      categoryValue: '5 Star',
      concept: 'Concept',
      conceptValue: 'Ultra All-Inclusive',
      totalArea: 'Total Area',
      totalAreaValue: '47,000 m²',
      capacity: 'Capacity',
      capacityValue: '460 Rooms',
      targetAudience: 'Target Audience',
      targetAudienceValue: 'Families, Couples, Honeymoon Guests',
      description: 'Holiday Inn Resort Bodrum West Beach will serve with an Ultra All-Inclusive concept with 460 rooms on a 47,000 m² area. We offer an unforgettable holiday experience with panoramic Aegean Sea views overlooking Kos and Kalymnos islands.',
    },
    location: {
      title: 'Location & Transportation',
      subtitle: 'Unique Location',
      address: 'Address',
      addressValue: 'Turgutreis, Bahçelievler Mah. Zeyyat Mandalinci Cad. No:164',
      view: 'View',
      viewValue: 'Panoramic Aegean Sea view overlooking Kos and Kalymnos islands',
      highlights: 'Highlights',
      highlightsValue: 'Near Turgutreis Marina, beachfront location',
      transport: 'Transportation',
      transportValue: 'Easy access to Bodrum city center and airport',
    },
    rooms: {
      title: 'Accommodation',
      subtitle: 'Modern & Comfortable Rooms',
      description: 'Wide accommodation options with 460 rooms. Room types suitable for every guest profile.',
      premium: {
        title: 'Premium Rooms',
        subtitle: 'High Comfort in Standard',
        size: '30 m²',
        description: 'Ideal for couples or families with one child. Modern design, balcony/terrace and elegant decoration.',
      },
      premiumSea: {
        title: 'Premium Sea View',
        subtitle: 'Every Shade of Blue',
        size: '30 m²',
        description: 'Panoramic Aegean Sea view. Spacious and peaceful atmosphere throughout the day, sunset pleasure.',
      },
      swimUp: {
        title: 'Swim-Up Rooms',
        subtitle: 'Privileged Holiday Experience',
        size: '30-40 m²',
        description: 'Direct pool access just a few steps from your terrace. Sunbathing terrace and sunbed available.',
      },
      family: {
        title: 'Family Rooms',
        subtitle: 'Ideal for Large Families',
        size: '40 m²',
        description: 'Spacious architecture providing comfortable movement area for parents and children. Layout for families of 4 to stay comfortably.',
      },
      connection: {
        title: 'Connection Rooms',
        subtitle: 'More Space',
        size: '60 m²',
        description: 'Combination of two separate rooms provides both togetherness and privacy.',
      },
      juniorSuite: {
        title: 'Junior Suite (1+1)',
        subtitle: 'Comfortable & Spacious',
        size: '80 m² (1+1)',
        description: 'Offers privileged accommodation with a spacious living area, modern design, and master bedroom.',
      },
      queenSuite: {
        title: 'Queen Suite (2+1)',
        subtitle: 'High-End Luxury',
        size: '105 m² (2+1)',
        description: 'Panoramic sea view, two bedrooms, and a spacious living room for perfect family comfort.',
      },
      kingSuite: {
        title: 'King Suite (3+1)',
        subtitle: 'Ultra Luxury & Prestige',
        size: '150 m² (3+1)',
        description: 'The ultimate holiday experience with large living spaces, three bedrooms, luxury details, and unique panoramic views.',
      },
      viewOptions: 'View Options',
      gardenView: 'Garden View',
      poolView: 'Pool View',
      seaView: 'Sea View',
    },
    dining: {
      title: 'Dining',
      subtitle: '24-Hour Taste Experience',
      concept: 'With our Ultra All-Inclusive concept, uninterrupted food service throughout the day from breakfast to night buffet.',
      premium: 'Premium Drinks: 3 different Whisky brands and 3 different Gin brands are offered free of charge within the concept.',
      mainRestaurant: {
        title: 'Main Restaurant',
        subtitle: 'Open Buffet Feast',
        breakfast: 'Breakfast: 07:00 – 10:00',
        lateBreakfast: 'Late Breakfast: 10:00 – 10:30',
        lunch: 'Lunch: 12:30 – 14:00',
        dinner: 'Dinner: 19:00 – 21:30',
        nightService: 'Night Service: Night Soup (23:00-24:00) and Night Buffet (00:00-02:00)',
      },
      snacks: {
        title: 'Snacks',
        subtitle: 'Energy All Day',
        items: [
          'Snack Restaurant: 12:00 – 16:00',
          'Beach Snack: 12:00 – 18:00',
          'Gözleme Corner: 11:00 – 14:30',
          'Waffle: 14:30 – 15:30',
          'Patisserie: 12:00 – 18:00',
        ],
      },
      alaCarte: {
        title: 'A La Carte Restaurants',
        subtitle: 'Selections from World Cuisines',
        italian: 'Italian Restaurant: 19:30 – 21:30 (6 days a week)',
        international: 'International Restaurant: 19:30 – 21:30 (6 days a week)',
        note: 'Reservation required and cover charge applies. Free once for minimum 5-night stays.',
      },
      bars: {
        title: 'Bars',
        subtitle: 'Pleasant Breaks and Premium Drinks',
        lobby: 'Lobby Bar: 24 Hours open',
        roof: 'Roof Bar: 19:00 – 24:00',
        pool: 'Pool Bar: 10:00 – 18:00 / 20:30 – 24:00',
        snack: 'Snack Bar: 11:00 – 17:30',
        beach: 'Beach Bar: 10:00 – 18:00',
      },
    },
    pool: {
      title: 'Pools & Beach',
      subtitle: 'A Refreshing Break',
      pools: {
        title: 'Pools',
        pool1: 'Outdoor Pool 1',
        pool2: 'Outdoor Pool 2',
        kids: 'Kids Pool',
        indoor: 'Indoor Pool',
        note: 'Pools close at 19:00 for cleaning.',
      },
      beach: {
        title: 'Beach',
        subtitle: 'Enjoy the Aegean',
        location: 'Beachfront location',
        features: 'Private beach area belonging to the resort',
        services: 'Umbrellas, sunbeds and beach towels are free',
        atmosphere: 'Vibrant coastal destination combined with modern comfort',
      },
    },
    spa: {
      title: 'Spa & Fitness',
      subtitle: 'Renewal and Dynamism',
      fitness: {
        title: 'Fitness Center',
        description: 'Gym equipped with state-of-the-art equipment.',
      },
      wellness: {
        title: 'Free Wellness',
        description: 'Turkish Bath and Sauna use.',
      },
      treatments: {
        title: 'Paid Treatments',
        description: 'Massage packages, special skin treatments and SPA rituals.',
      },
      goal: 'Maintain your physical fitness and relax mentally.',
    },
    entertainment: {
      title: 'Entertainment & Activities',
      subtitle: 'Catch the Rhythm of Your Holiday',
      liveMusic: {
        title: 'Live Music',
        description: 'Live music pleasure with professional orchestras 3 days a week.',
      },
      themeShows: {
        title: 'Theme Shows',
        description: 'Special theme nights colored with performing arts and visual shows 3 days a week.',
      },
      dayActivities: {
        title: 'Day Activities',
        description: 'Animation events and pool games throughout the day.',
      },
      aerobics: {
        title: 'Aerobics',
        description: 'Energetic Aerobics sessions with expert trainers.',
      },
    },
    kids: {
      title: 'Kids Club',
      subtitle: 'Great Fun for Little Guests',
      ageGroup: 'Age Group',
      ageGroupValue: '4-12 years',
      hours: 'Hours',
      hoursValue: '10:00-12:30 and 14:30-17:00',
      pool: 'Kids Pool',
      poolValue: '84 m² in size, 40 cm safe depth',
      activities: 'Activities',
      activitiesValue: 'Play, creativity and discovery activities with experienced trainers.',
    },
    services: {
      title: 'Services',
      subtitle: 'Paid & Free Services',
      free: {
        title: 'Free Services',
        items: ['Wi-Fi (All areas)', 'Parking', 'Table Tennis', 'Darts', 'Baby Bed'],
      },
      paid: {
        title: 'Paid Services',
        items: ['Doctor', 'Laundry', 'Room Service (00:00-08:00)', 'Water Sports', 'Hairdresser', 'Market', 'Car Rental'],
      },
    },
    contact: {
      title: 'Contact',
      subtitle: 'What You Need to Know',
      checkIn: 'Check-in',
      checkInValue: '14:00',
      checkOut: 'Check-out',
      checkOutValue: '12:00',
      pets: 'Pets',
      petsValue: 'Not accepted',
      wristband: 'Wristband',
      wristbandValue: 'Wristband use is mandatory at the resort',
      form: {
        title: 'Contact Us',
        name: 'Your Name',
        email: 'Email',
        phone: 'Phone',
        subject: 'Subject',
        message: 'Your Message',
        send: 'Send',
        success: 'Your message has been sent successfully!',
      },
    },
    gallery: {
      title: 'Gallery',
      subtitle: 'Photo Gallery',
      all: 'All',
      rooms: 'Rooms',
      restaurants: 'Restaurants',
      pool: 'Pool',
      beach: 'Beach',
      spa: 'Spa',
    },
    footer: {
      quickLinks: 'Quick Links',
      contact: 'Contact',
      followUs: 'Follow Us',
      rights: '© 2026 Holiday Inn Resort Bodrum West Beach. All rights reserved.',
      ihg: 'IHG Hotels & Resorts',
    },
    common: {
      learnMore: 'Learn More',
      viewAll: 'View All',
      close: 'Close',
      loading: 'Loading...',
      error: 'An error occurred',
      required: 'Required field',
    },
  },
  de: {
    nav: {
      home: 'Startseite',
      about: 'Über uns',
      rooms: 'Zimmer',
      dining: 'Essen & Trinken',
      spa: 'Spa & Fitness',
      pool: 'Pool & Strand',
      entertainment: 'Unterhaltung',
      kids: 'Kinderclub',
      gallery: 'Galerie',
      contact: 'Kontakt',
      bookNow: 'Buchen',
    },
    hero: {
      title: 'Die neueste Perle der Ägäis',
      subtitle: 'Holiday Inn Resort Bodrum West Beach',
      opening: '',
      concept: 'Ultra All-Inclusive & Familienfreundlich',
      location: 'Turgutreis, Bodrum',
      cta: 'Reservieren',
    },
    about: {
      title: 'WILLKOMMEN',
      subtitle: 'Über das Resort',
      openingDate: '',
      openingDateValue: '',
      category: 'Kategorie',
      categoryValue: '5 Sterne',
      concept: 'Konzept',
      conceptValue: 'Ultra All-Inclusive',
      totalArea: 'Gesamtfläche',
      totalAreaValue: '47.000 m²',
      capacity: 'Kapazität',
      capacityValue: '460 Zimmer',
      targetAudience: 'Zielgruppe',
      targetAudienceValue: 'Familien, Paare, Flitterwochen-Gäste',
      description: 'Das Holiday Inn Resort Bodrum West Beach bietet auf 47.000 m² mit 460 Zimmern ein Ultra-All-Inclusive-Konzept. Wir bieten ein unvergessliches Urlaubserlebnis mit Panoramablick auf die Ägäis mit Blick auf die Inseln Kos und Kalymnos.',
    },
    location: {
      title: 'Lage & Transport',
      subtitle: 'Einzigartige Lage',
      address: 'Adresse',
      addressValue: 'Turgutreis, Bahçelievler Mah. Zeyyat Mandalinci Cad. No:164',
      view: 'Aussicht',
      viewValue: 'Panoramablick auf die Ägäis mit Blick auf die Inseln Kos und Kalymnos',
      highlights: 'Highlights',
      highlightsValue: 'In der Nähe der Turgutreis Marina, direkt am Strand',
      transport: 'Transport',
      transportValue: 'Einfacher Zugang zum Stadtzentrum und Flughafen von Bodrum',
    },
    rooms: {
      title: 'Unterkunft',
      subtitle: 'Moderne & Komfortable Zimmer',
      description: 'Breite Unterkunftsmöglichkeiten mit 460 Zimmern. Zimmertypen für jedes Gästeprofil.',
      premium: {
        title: 'Premium Zimmer',
        subtitle: 'Hoher Komfort im Standard',
        size: '30 m²',
        description: 'Ideal für Paare oder Familien mit einem Kind. Modernes Design, Balkon/Terrasse und elegante Dekoration.',
      },
      premiumSea: {
        title: 'Premium Meerblick',
        subtitle: 'Jede Schattierung von Blau',
        size: '30 m²',
        description: 'Panoramablick auf die Ägäis. Geräumige und friedliche Atmosphäre den ganzen Tag, Sonnenuntergangsgenuss.',
      },
      swimUp: {
        title: 'Swim-Up Zimmer',
        subtitle: 'Privilegiertes Urlaubserlebnis',
        size: '30-40 m²',
        description: 'Direkter Poolzugang nur wenige Schritte von Ihrer Terrasse entfernt. Sonnenterrasse und Liege verfügbar.',
      },
      family: {
        title: 'Familienzimmer',
        subtitle: 'Ideal für große Familien',
        size: '40 m²',
        description: 'Geräumige Architektur mit komfortablem Bewegungsraum für Eltern und Kinder. Layout für Familien mit 4 Personen.',
      },
      connection: {
        title: 'Verbindungszimmer',
        subtitle: 'Mehr Platz',
        size: '60 m²',
        description: 'Kombination aus zwei separaten Zimmern bietet sowohl Zusammensein als auch Privatsphäre.',
      },
      juniorSuite: {
        title: 'Junior Suite (1+1)',
        subtitle: 'Komfortabel & Geräumig',
        size: '80 m² (1+1)',
        description: 'Bietet eine privilegierte Unterkunft mit geräumigem Wohnbereich, modernem Design und Hauptschlafzimmer.',
      },
      queenSuite: {
        title: 'Queen Suite (2+1)',
        subtitle: 'Erstklassiger Luxus',
        size: '105 m² (2+1)',
        description: 'Panoramablick auf das Meer, zwei Schlafzimmer und ein geräumiges Wohnzimmer für perfekten Familienkomfort.',
      },
      kingSuite: {
        title: 'King Suite (3+1)',
        subtitle: 'Ultra-Luxus & Prestige',
        size: '150 m² (3+1)',
        description: 'Das ultimative Urlaubserlebnis mit großen Wohnräumen, drei Schlafzimmern, luxuriösen Details und einzigartigem Panoramablick.',
      },
      viewOptions: 'Aussichtsoptionen',
      gardenView: 'Gartenblick',
      poolView: 'Poolblick',
      seaView: 'Meerblick',
    },
    dining: {
      title: 'Essen & Trinken',
      subtitle: '24-Stunden Geschmackserlebnis',
      concept: 'Mit unserem Ultra All-Inclusive Konzept, ununterbrochener Speiseservice den ganzen Tag vom Frühstück bis zum Nachtbuffet.',
      premium: 'Premium-Getränke: 3 verschiedene Whisky-Marken und 3 verschiedene Gin-Marken werden kostenlos im Konzept angeboten.',
      mainRestaurant: {
        title: 'Hauptrestaurant',
        subtitle: 'Offenes Buffet Fest',
        breakfast: 'Frühstück: 07:00 – 10:00',
        lateBreakfast: 'Spätes Frühstück: 10:00 – 10:30',
        lunch: 'Mittagessen: 12:30 – 14:00',
        dinner: 'Abendessen: 19:00 – 21:30',
        nightService: 'Nachtservice: Nachtsuppe (23:00-24:00) und Nachtbuffet (00:00-02:00)',
      },
      snacks: {
        title: 'Snacks',
        subtitle: 'Energie den ganzen Tag',
        items: [
          'Snack Restaurant: 12:00 – 16:00',
          'Strand Snack: 12:00 – 18:00',
          'Gözleme Ecke: 11:00 – 14:30',
          'Waffel: 14:30 – 15:30',
          'Konditorei: 12:00 – 18:00',
        ],
      },
      alaCarte: {
        title: 'A La Carte Restaurants',
        subtitle: 'Auswahl aus Weltküchen',
        italian: 'Italienisches Restaurant: 19:30 – 21:30 (6 Tage die Woche)',
        international: 'Internationales Restaurant: 19:30 – 21:30 (6 Tage die Woche)',
        note: 'Reservierung erforderlich und Kuvertgebühr. Einmal kostenlos bei mindestens 5 Übernachtungen.',
      },
      bars: {
        title: 'Bars',
        subtitle: 'Angenehme Pausen und Premium-Getränke',
        lobby: 'Lobby Bar: 24 Stunden geöffnet',
        roof: 'Roof Bar: 19:00 – 24:00',
        pool: 'Pool Bar: 10:00 – 18:00 / 20:30 – 24:00',
        snack: 'Snack Bar: 11:00 – 17:30',
        beach: 'Strand Bar: 10:00 – 18:00',
      },
    },
    pool: {
      title: 'Pools & Strand',
      subtitle: 'Eine erfrischende Pause',
      pools: {
        title: 'Pools',
        pool1: 'Außenpool 1',
        pool2: 'Außenpool 2',
        kids: 'Kinderpool',
        indoor: 'Innenpool',
        note: 'Pools schließen um 19:00 zur Reinigung.',
      },
      beach: {
        title: 'Strand',
        subtitle: 'Genießen Sie die Ägäis',
        location: 'Direkt am Strand',
        features: 'Privater Strandbereich des Resorts',
        services: 'Sonnenschirme, Liegen und Strandtücher sind kostenlos',
        atmosphere: 'Lebhaftes Küstenziel kombiniert mit modernem Komfort',
      },
    },
    spa: {
      title: 'Spa & Fitness',
      subtitle: 'Erneuerung und Dynamik',
      fitness: {
        title: 'Fitnesscenter',
        description: 'Fitnessstudio mit modernster Ausstattung.',
      },
      wellness: {
        title: 'Kostenloses Wellness',
        description: 'Türkisches Bad und Sauna.',
      },
      treatments: {
        title: 'Kostenpflichtige Behandlungen',
        description: 'Massagepakete, spezielle Hautbehandlungen und SPA-Rituale.',
      },
      goal: 'Erhalten Sie Ihre körperliche Fitness und entspannen Sie mental.',
    },
    entertainment: {
      title: 'Unterhaltung & Aktivitäten',
      subtitle: 'Fangen Sie den Rhythmus Ihres Urlaubs',
      liveMusic: {
        title: 'Live-Musik',
        description: 'Live-Musik-Vergnügen mit professionellen Orchestern 3 Tage die Woche.',
      },
      themeShows: {
        title: 'Themen-Shows',
        description: 'Besondere Themenabende mit darstellenden Künsten und visuellen Shows 3 Tage die Woche.',
      },
      dayActivities: {
        title: 'Tagesaktivitäten',
        description: 'Animationsveranstaltungen und Poolspiele den ganzen Tag.',
      },
      aerobics: {
        title: 'Aerobic',
        description: 'Energiegeladene Aerobic-Sessions mit erfahrenen Trainern.',
      },
    },
    kids: {
      title: 'Kinderclub',
      subtitle: 'Großer Spaß für kleine Gäste',
      ageGroup: 'Altersgruppe',
      ageGroupValue: '4-12 Jahre',
      hours: 'Öffnungszeiten',
      hoursValue: '10:00-12:30 und 14:30-17:00',
      pool: 'Kinderpool',
      poolValue: '84 m² groß, 40 cm sichere Tiefe',
      activities: 'Aktivitäten',
      activitiesValue: 'Spiel-, Kreativitäts- und Entdeckungsaktivitäten mit erfahrenen Trainern.',
    },
    services: {
      title: 'Dienstleistungen',
      subtitle: 'Kostenpflichtige & Kostenlose Dienste',
      free: {
        title: 'Kostenlose Dienste',
        items: ['WLAN (Alle Bereiche)', 'Parkplatz', 'Tischtennis', 'Darts', 'Babybett'],
      },
      paid: {
        title: 'Kostenpflichtige Dienste',
        items: ['Arzt', 'Wäscherei', 'Zimmerservice (00:00-08:00)', 'Wassersport', 'Friseur', 'Markt', 'Autovermietung'],
      },
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Was Sie wissen müssen',
      checkIn: 'Check-in',
      checkInValue: '14:00',
      checkOut: 'Check-out',
      checkOutValue: '12:00',
      pets: 'Haustiere',
      petsValue: 'Nicht erlaubt',
      wristband: 'Armband',
      wristbandValue: 'Armband ist im Resort Pflicht',
      form: {
        title: 'Kontaktieren Sie uns',
        name: 'Ihr Name',
        email: 'E-Mail',
        phone: 'Telefon',
        subject: 'Betreff',
        message: 'Ihre Nachricht',
        send: 'Senden',
        success: 'Ihre Nachricht wurde erfolgreich gesendet!',
      },
    },
    gallery: {
      title: 'Galerie',
      subtitle: 'Fotogalerie',
      all: 'Alle',
      rooms: 'Zimmer',
      restaurants: 'Restaurants',
      pool: 'Pool',
      beach: 'Strand',
      spa: 'Spa',
    },
    footer: {
      quickLinks: 'Schnellzugriff',
      contact: 'Kontakt',
      followUs: 'Folgen Sie uns',
      rights: '© 2026 Holiday Inn Resort Bodrum West Beach. Alle Rechte vorbehalten.',
      ihg: 'IHG Hotels & Resorts',
    },
    common: {
      learnMore: 'Mehr erfahren',
      viewAll: 'Alle anzeigen',
      close: 'Schließen',
      loading: 'Laden...',
      error: 'Ein Fehler ist aufgetreten',
      required: 'Pflichtfeld',
    },
  },
  ru: {
    nav: {
      home: 'Главная',
      about: 'О нас',
      rooms: 'Номера',
      dining: 'Питание',
      spa: 'Спа и Фитнес',
      pool: 'Бассейн и Пляж',
      entertainment: 'Развлечения',
      kids: 'Детский клуб',
      gallery: 'Галерея',
      contact: 'Контакты',
      bookNow: 'Забронировать',
    },
    hero: {
      title: 'Новая жемчужина Эгейского моря',
      subtitle: 'Holiday Inn Resort Bodrum West Beach',
      opening: '',
      concept: 'Ультра Все Включено и для Семей',
      location: 'Тургутрейс, Бодрум',
      cta: 'Забронировать',
    },
    about: {
      title: 'ДОБРО ПОЖАЛОВАТЬ',
      subtitle: 'О курорте',
      openingDate: '',
      openingDateValue: '',
      category: 'Категория',
      categoryValue: '5 звезд',
      concept: 'Концепция',
      conceptValue: 'Ультра Все Включено',
      totalArea: 'Общая площадь',
      totalAreaValue: '47 000 м²',
      capacity: 'Вместимость',
      capacityValue: '460 номеров',
      targetAudience: 'Целевая аудитория',
      targetAudienceValue: 'Семьи, Пары, Молодожёны',
      description: 'Holiday Inn Resort Bodrum West Beach будет работать по системе Ультра Все Включено с 460 номерами на площади 47 000 м². Мы предлагаем незабываемый отдых с панорамным видом на Эгейское море и острова Кос и Калимнос.',
    },
    location: {
      title: 'Расположение и Транспорт',
      subtitle: 'Уникальное расположение',
      address: 'Адрес',
      addressValue: 'Тургутрейс, Bahçelievler Mah. Zeyyat Mandalinci Cad. No:164',
      view: 'Вид',
      viewValue: 'Панорамный вид на Эгейское море с видом на острова Кос и Калимнос',
      highlights: 'Особенности',
      highlightsValue: 'Рядом с мариной Тургутрейс, первая линия',
      transport: 'Транспорт',
      transportValue: 'Удобный доступ к центру города и аэропорту Бодрума',
    },
    rooms: {
      title: 'Размещение',
      subtitle: 'Современные и Комфортные Номера',
      description: 'Широкий выбор размещения с 460 номерами. Типы номеров для каждого профиля гостя.',
      premium: {
        title: 'Премиум номера',
        subtitle: 'Высокий комфорт в стандарте',
        size: '30 м²',
        description: 'Идеально для пар или семей с одним ребенком. Современный дизайн, балкон/терраса и элегантное оформление.',
      },
      premiumSea: {
        title: 'Премиум с видом на море',
        subtitle: 'Все оттенки синего',
        size: '30 м²',
        description: 'Панорамный вид на Эгейское море. Просторная и спокойная атмосфера весь день, удовольствие от заката.',
      },
      swimUp: {
        title: 'Номера Swim-Up',
        subtitle: 'Привилегированный отдых',
        size: '30-40 м²',
        description: 'Прямой доступ к бассейну всего в нескольких шагах от террасы. Терраса для загара и шезлонги.',
      },
      family: {
        title: 'Семейные номера',
        subtitle: 'Идеально для больших семей',
        size: '40 м²',
        description: 'Просторная архитектура с комфортным пространством для родителей и детей. Планировка для семей из 4 человек.',
      },
      connection: {
        title: 'Смежные номера',
        subtitle: 'Больше пространства',
        size: '60 м²',
        description: 'Комбинация двух отдельных номеров обеспечивает и единство, и приватность.',
      },
      juniorSuite: {
        title: 'Полулюкс / Junior Suite (1+1)',
        subtitle: 'Комфортный и просторный',
        size: '80 м² (1+1)',
        description: 'Привилегированное размещение с просторной гостиной зоной, современным дизайном и спальней.',
      },
      queenSuite: {
        title: 'Королевский люкс / Queen Suite (2+1)',
        subtitle: 'Высший уровень роскоши',
        size: '105 м² (2+1)',
        description: 'Панорамный вид на море, две спали и просторная гостиная для безупречного семейного комфорта.',
      },
      kingSuite: {
        title: 'Королевский люкс / King Suite (3+1)',
        subtitle: 'Ультра-роскошь и престиж',
        size: '150 м² (3+1)',
        description: 'Исключительный отдых с тремя спальнями, просторными гостиными, роскошными деталями и панорамным видом.',
      },
      viewOptions: 'Варианты вида',
      gardenView: 'Вид на сад',
      poolView: 'Вид на бассейн',
      seaView: 'Вид на море',
    },
    dining: {
      title: 'Питание',
      subtitle: '24-часовой гастрономический опыт',
      concept: 'С нашей концепцией Ультра Все Включено непрерывное обслуживание питанием весь день от завтрака до ночного буфета.',
      premium: 'Премиум напитки: 3 различных бренда виски и 3 различных бренда джина предлагаются бесплатно в рамках концепции.',
      mainRestaurant: {
        title: 'Главный ресторан',
        subtitle: 'Праздник шведского стола',
        breakfast: 'Завтрак: 07:00 – 10:00',
        lateBreakfast: 'Поздний завтрак: 10:00 – 10:30',
        lunch: 'Обед: 12:30 – 14:00',
        dinner: 'Ужин: 19:00 – 21:30',
        nightService: 'Ночной сервис: Ночной суп (23:00-24:00) и Ночной буфет (00:00-02:00)',
      },
      snacks: {
        title: 'Закуски',
        subtitle: 'Энергия весь день',
        items: [
          'Снэк-ресторан: 12:00 – 16:00',
          'Пляжный снэк: 12:00 – 18:00',
          'Гёзлеме: 11:00 – 14:30',
          'Вафли: 14:30 – 15:30',
          'Кондитерская: 12:00 – 18:00',
        ],
      },
      alaCarte: {
        title: 'Рестораны A La Carte',
        subtitle: 'Избранное мировых кухонь',
        italian: 'Итальянский ресторан: 19:30 – 21:30 (6 дней в неделю)',
        international: 'Международный ресторан: 19:30 – 21:30 (6 дней в неделю)',
        note: 'Требуется бронирование, куверт платный. Бесплатно один раз при проживании от 5 ночей.',
      },
      bars: {
        title: 'Бары',
        subtitle: 'Приятные перерывы и премиум напитки',
        lobby: 'Лобби-бар: 24 часа',
        roof: 'Руфтоп-бар: 19:00 – 24:00',
        pool: 'Бар у бассейна: 10:00 – 18:00 / 20:30 – 24:00',
        snack: 'Снэк-бар: 11:00 – 17:30',
        beach: 'Пляжный бар: 10:00 – 18:00',
      },
    },
    pool: {
      title: 'Бассейны и Пляж',
      subtitle: 'Освежающий перерыв',
      pools: {
        title: 'Бассейны',
        pool1: 'Открытый бассейн 1',
        pool2: 'Открытый бассейн 2',
        kids: 'Детский бассейн',
        indoor: 'Крытый бассейн',
        note: 'Бассейны закрываются в 19:00 на уборку.',
      },
      beach: {
        title: 'Пляж',
        subtitle: 'Наслаждайтесь Эгейским морем',
        location: 'Первая линия',
        features: 'Частный пляж курорта',
        services: 'Зонты, шезлонги и пляжные полотенца бесплатно',
        atmosphere: 'Яркое побережье в сочетании с современным комфортом',
      },
    },
    spa: {
      title: 'Спа и Фитнес',
      subtitle: 'Обновление и динамика',
      fitness: {
        title: 'Фитнес-центр',
        description: 'Тренажерный зал с современным оборудованием.',
      },
      wellness: {
        title: 'Бесплатный велнес',
        description: 'Турецкая баня и сауна.',
      },
      treatments: {
        title: 'Платные процедуры',
        description: 'Массажные пакеты, специальные процедуры для кожи и СПА-ритуалы.',
      },
      goal: 'Поддерживайте физическую форму и расслабляйтесь морально.',
    },
    entertainment: {
      title: 'Развлечения и Активности',
      subtitle: 'Поймайте ритм вашего отпуска',
      liveMusic: {
        title: 'Живая музыка',
        description: 'Удовольствие от живой музыки с профессиональными оркестрами 3 дня в неделю.',
      },
      themeShows: {
        title: 'Тематические шоу',
        description: 'Особые тематические вечера с представлениями и визуальными шоу 3 дня в неделю.',
      },
      dayActivities: {
        title: 'Дневные активности',
        description: 'Анимационные мероприятия и игры у бассейна весь день.',
      },
      aerobics: {
        title: 'Аэробика',
        description: 'Энергичные занятия аэробикой с опытными тренерами.',
      },
    },
    kids: {
      title: 'Детский клуб',
      subtitle: 'Большое веселье для маленьких гостей',
      ageGroup: 'Возраст',
      ageGroupValue: '4-12 лет',
      hours: 'Часы работы',
      hoursValue: '10:00-12:30 и 14:30-17:00',
      pool: 'Детский бассейн',
      poolValue: '84 м², безопасная глубина 40 см',
      activities: 'Активности',
      activitiesValue: 'Игры, творчество и познавательные занятия с опытными воспитателями.',
    },
    services: {
      title: 'Услуги',
      subtitle: 'Платные и Бесплатные услуги',
      free: {
        title: 'Бесплатные услуги',
        items: ['Wi-Fi (Все зоны)', 'Парковка', 'Настольный теннис', 'Дартс', 'Детская кроватка'],
      },
      paid: {
        title: 'Платные услуги',
        items: ['Врач', 'Прачечная', 'Обслуживание номеров (00:00-08:00)', 'Водные виды спорта', 'Парикмахер', 'Магазин', 'Аренда авто'],
      },
    },
    contact: {
      title: 'Контакты',
      subtitle: 'Что нужно знать',
      checkIn: 'Заезд',
      checkInValue: '14:00',
      checkOut: 'Выезд',
      checkOutValue: '12:00',
      pets: 'Питомцы',
      petsValue: 'Не принимаются',
      wristband: 'Браслет',
      wristbandValue: 'Ношение браслета обязательно на территории курорта',
      form: {
        title: 'Свяжитесь с нами',
        name: 'Ваше имя',
        email: 'Электронная почта',
        phone: 'Телефон',
        subject: 'Тема',
        message: 'Ваше сообщение',
        send: 'Отправить',
        success: 'Ваше сообщение успешно отправлено!',
      },
    },
    gallery: {
      title: 'Галерея',
      subtitle: 'Фотогалерея',
      all: 'Все',
      rooms: 'Номера',
      restaurants: 'Рестораны',
      pool: 'Бассейн',
      beach: 'Пляж',
      spa: 'Спа',
    },
    footer: {
      quickLinks: 'Быстрые ссылки',
      contact: 'Контакты',
      followUs: 'Подписывайтесь',
      rights: '© 2026 Holiday Inn Resort Bodrum West Beach. Все права защищены.',
      ihg: 'IHG Hotels & Resorts',
    },
    common: {
      learnMore: 'Подробнее',
      viewAll: 'Смотреть все',
      close: 'Закрыть',
      loading: 'Загрузка...',
      error: 'Произошла ошибка',
      required: 'Обязательное поле',
    },
  },
};

export const languages = [
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
];
